import React, { useEffect, useState } from 'react';
import { Input, FormFeedback } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faEdit, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export const UpdateDashboardTitle = props => {
  const EMPTY_TITLE = 'Title cannot be empty';
  const [isEdit, setEdit] = useState(false);
  const [titleError, setTitleError] = useState('');
  const [title, setTitle] = useState('');
  // Use to reset value
  const [pureTitle, setPureTitle] = useState('');

  useEffect(() => {
    if (props.title) {
      setTitle(props.title);
      setPureTitle(props.title);
    }
  }, [props.title]);

  const saveTitle = e => {
    if (e.target.value === '') {
      setTitleError(EMPTY_TITLE);
    } else {
      setTitleError('');
    }
    setTitle(e.target.value);
  };

  return (
    <div className="db-info">
      <Link to="/dashboard">
        <div className="db-group">My Dashboard</div>
      </Link>
      <FontAwesomeIcon icon={faChevronRight} />
      <div className="db-title-container">
        {!isEdit ? (
          <>
            <div className="db-title">{title === '' ? 'Untitled Dashboard' : title}</div>
            <FontAwesomeIcon
              icon={faEdit}
              title="edit"
              onClick={() => {
                if (title === '') {
                  setTitleError(EMPTY_TITLE);
                }
                setEdit(true);
              }}
              style={{ cursor: 'pointer', color: '#168884' }}
            />
          </>
        ) : (
          <>
            <Input
              id="dashboard-title"
              invalid={titleError !== ''}
              value={title}
              placeholder="Untitled Dashboard"
              maxLength={100}
              onKeyDown={e => {
                if (e.key === 'Enter' && titleError === '') {
                  props.saveTitle(title);
                  setPureTitle(title);
                  setEdit(false);
                }
              }}
              onChange={e => {
                saveTitle(e);
              }}
            />
            {titleError && <FormFeedback>{titleError}</FormFeedback>}
            <FontAwesomeIcon
              icon={faCheck}
              className="db-title-save"
              onClick={() => {
                if (titleError === '') {
                  props.saveTitle(title);
                  setPureTitle(title);
                  setEdit(false);
                }
              }}
              style={{ cursor: 'pointer' }}
            />
            <FontAwesomeIcon
              icon={faTimes}
              className="db-title-reset"
              onClick={() => {
                setEdit(false);
                setTitle(pureTitle);
                setTitleError('');
              }}
              style={{ cursor: 'pointer' }}
            />
          </>
        )}
      </div>
    </div>
  );
};
